
export class SaveDataResult {
    constructor(public ok = false, public data: any = null) { 
    }
}